import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Accommodation = () => {
  const show = true;
  if (show) {

    return (
      <React.Fragment>
        <SEO title="Accommodation | DMBD 2023" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"
        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
            <h3 align="center" >
              Reserving a Room at Venue Hotel{" "}
              <a href="https://www.ihg.com.cn/crowneplaza/hotels/cn/zh/sanya/syxcc/hoteldetail">
                Crowne Plaza Sanya City Center(三亚中心皇冠假日酒店)
                {" "}
              </a> !
            </h3>
            <hr></hr>
            {/* <br></br> */}
            {/* <p align="left">
              一些酒店信息 未修改
              <br />
              1. All participants are highly recommendated to make a reservation
              at Qingdao Blue Horizon Hotel Laoshan in Qingdao.
              <br />
              2.Considering July is a tourism-peak season of Qingdao, it&apos;s
              may hard for you to find an available accommodation with reasonable
              price nearby the venue hotel, the secretariat offers our
              participants a reservation service.
              <br />
              3. We highly recommend our participants make your reservation ASAP
              before July 9th 23:59:59 GMT+8! It is very convenient for you to
              attend our technical/social acitvities during the confenerce.
              <br />
              4. We provide an official WeChat group for participants to
              communicate, if you are looking for a roommate during conference,
              please scan the following QR code.
              <br />
              <p align="center">
                <img src="./wechat.jpg" alt="" width="200px" />
              </p>
            </p> */}

            <div className="entry-content">
              <h4>About the venue hotel</h4>
              <br></br>
              <p>
                Crowne Plaza Sanya City Center is conveniently located on Yuya Road, a scenic thoroughfare running along Yulin Harbor. We are 17 kilometers from Sanya Phoenix International Airport and 11 kilometers from Sanya Railway Station. Nearby attractions and points of interest include Sanya International Yacht Club, Bar Street and Sanya International Shopping Center. Putting you close to nearby Dadonghai Beach, Mountainous Luhuitou Park and popular Sanya No.1 Market Sanya, where you can enjoy all of the authentic flavors of Hainan. Sanya is China`&apos;s tropical city, welcoming you to paradise.
                <br></br><br></br>
                The hotel offers 490 finely appointed guest rooms and suites, all with flat-screen television, satellite channels, a spacious work desk with ergonomic seating and wireless high-speed internet access. Crowne Plaza Executive Lounge is located on the 16th floor, and provides personalized services to meet the unique needs of discerning business and leisure travelers.
                <br></br><br></br>
                For a perfect night`&apos;s sleep, the hotel offer the Crowne Plaza Sleep Advantage program providing in-room options such as ergonomic pillow selection (facing-up,facing-side or facing-down pillow),Crowne Style or Lavender aromatherapy and your choice of warm milk or red wine. Sleep Advantage items are delivered within 15 minutes upon request.

                <br></br>
                <br></br>
                {/* For more information about the hotel, please visit the website: https://www.ihg.com/crowneplaza/hotels/us/en/sanya/syxcc/hoteldetail */}
              </p>

              <h4>Hotel room</h4>
              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/sanya/accom1.png" />              </td>
                    <td width="50%">
                      <img src="images/sanya/accom2.png" />              </td>
                    {/* <td width="50%">
                      <img src="images/sanya/accom8.png" />              </td> */}
                  </tr>
                </table>
              </div>

              <h4>
                Restaurant
              </h4>

              <br></br>
              <h5>
                Café Marina
              </h5>

              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/sanya/accom3.png" />
                    </td>
                    <td width="50%">
                      <img src="images/sanya/accom4.png" />
                    </td>
                  </tr>
                </table>
              </div>

              <h5>
                Yue Chao Cantonese Restaurant
              </h5>

              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/sanya/accom5.png" />
                    </td>
                    <td width="50%">
                      <img src="images/sanya/accom6.png" />
                    </td>
                  </tr>
                </table>
              </div>
              <h4>
                Recreational Facilities
              </h4>

              <br></br>
              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/sanya/accom7.png" />
                    </td>
                    <td width="50%">
                      <img src="images/sanya/accom9.png" />
                    </td>
                  </tr>

                </table>



              </div>


              <br></br>
              <h4>
                <b>
                  More about accommodation: Please download the{" "}
                  <a href="files/2023-Crowne Plaza Sanya City Center.pptx" target="_blank">
                    hotel introduction
                  </a> or visit the  <a href="https://www.ihg.com/crowneplaza/hotels/us/en/sanya/syxcc/hoteldetail">website</a>.
                </b>
              </h4>
            </div>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment >
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Accommodation | DMBD 2023" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h3>To be released.</h3>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Accommodation;
